// markup
import Button from "@material-ui/core/Button";

import _ from "underscore";
import { effectiveRiskLevel } from "../../../shared/dictionary/enums";

const TableCellApplicationActions = (props) => {
  let noActionText = "No action Available";
  let isEmptyGuid =
    props.item.DirectDebitAccountId === "00000000-0000-0000-0000-000000000000";

  let stateAwaitingReview =
    props.item.Stage === "AwaitingCompletion" ||
    props.item.Stage === "AwaitingManualReview" ||
    props.item.Stage === "OnHold";

  let alreadyHandled =
    props.item.Stage === "ManuallyApproved" ||
    props.item.Stage === "ManuallyRejected";

  if (!stateAwaitingReview)
    noActionText = "Cannot approve application in this stage";
  else if (isEmptyGuid)
    noActionText = "User did not select direct debit account";

  const isHighOrUnacceptableRiskLevel =
    props.item.EffectiveRiskLevel === effectiveRiskLevel.High ||
    props.item.EffectiveRiskLevel === effectiveRiskLevel.Unacceptable;
  let isApproveDisabled =
    isEmptyGuid || !stateAwaitingReview || isHighOrUnacceptableRiskLevel; //&& import.meta.env.MODE != 'development';

  return !alreadyHandled ? (
    <div className="table-cell-actions">
      <Button
        className="approveReject"
        variant="contained"
        color="primary"
        disabled={isApproveDisabled}
        onClick={handleConfirm}
        style={{ marginRight: "2px" }}
      >
        Approve
      </Button>
      <Button
        variant="contained"
        color="primary"
        style={{ marginRight: "2px" }}
        onClick={putOnHold}
      >
        Put on hold
      </Button>
      <Button
        className="approveReject"
        variant="contained"
        color="primary"
        onClick={handleReject}
        style={{ marginLeft: "2px" }}
      >
        Reject
      </Button>
      {props.dropSingle ? (
        <Button
          variant="contained"
          color="primary"
          onClick={props.dropSingle.bind(this, props.item.Id)}
        >
          unassign
        </Button>
      ) : undefined}
    </div>
  ) : (
    <div className="table-cell-actions">{noActionText}</div>
  );

  function handleReject() {
    props.rejectApplication(props.item.Id);

    if (props.dropSingle) {
      props.dropSingle(props.item.Id);
    }
  }

  function handleConfirm() {
    const acceptedOffers = props.item.LoanOffers.filter((offer) => {
      return offer.Accepted;
    });
    const ordersSorted = _.sortBy(acceptedOffers, (offer) => {
      return new Date(offer.DateAccepted);
    });
    // get the last accepted offer
    const acceptedOfferId = ordersSorted[acceptedOffers.length - 1].Id;

    props.approveApplication(props.item.Id, acceptedOfferId);

    if (props.dropSingle) {
      props.dropSingle(props.item.Id);
    }
  }

  function putOnHold() {
    props.moveToReview(props.item.Id);

    if (props.dropSingle) {
      props.dropSingle(props.item.Id);
    }
  }
};

export default TableCellApplicationActions;
